<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header"><h1>{{$t('prenotazione.storico')}}</h1></div>
            <div class="content content-full">
                <div class="title">{{$t('prenotazione.effettuate')}}</div>
                <div class="container">
                    <div class="row-sezione">
                        <div class="blocchetto p-0" v-for="reservation in this.reservations">
                          <div class="d-flex justify-content-between">
                            <router-link :to="{name:'reservations.details', params:{id:reservation.id}}" class="flex-grow-1 a1 p-2">
                              {{$t('prenotazione')}} n°: {{reservation.id}}<br>
                              <b>
                                  {{reservation.n_persone}} {{$tc('prenotazioni_tavolo.persona', reservation.n_persone)}}
                                  <br>
                                  <span class="text-capitalize">
                                    {{moment(reservation.data_ora_prenotazione).locale(language).format('dddd DD MMMM YYYY')}}
                                  </span>
                                  {{$t('ore_in_data')}}
                                  {{moment(reservation.data_ora_prenotazione).locale(language).format('HH:mm')}}
                              </b><br>
                              {{$t('prenotazione.status')}}:
                              <inc-reservation-status :status="reservation.status"/>
                            </router-link>

                          <div class="d-flex flex-column align-items-stretch">
                                <a href="#" @click.prevent="openMessagingModal(reservation)" class="link-modal-messaggeria">
                                  <div class="d-flex align-items-center align-items-stretch bg-color-dark my-0 h-100" style="padding: 6px;">
                                    <span class="material-symbols-outlined icone40" v-tooltip:bottom="$t('messaggistica')">
                                        mark_as_unread
                                        </span>
                                    <span class="badge badge-info" v-if="getConversationMsgCounter(reservation)">
                                            {{getConversationMsgCounter(reservation)}}</span>
                                  </div>
                                </a>

                            <a href="#" @click.prevent="openFeedbackModal(order)" class="link-modal-messaggeria d-none">
                              <div class="d-flex align-items-center align-items-stretch bg-color-dark my-0 h-100" style="padding: 6px;">
                                      <span class="material-symbols-outlined icone40" v-tooltip:bottom="$t('feedback')">
                                        star_rate
                                      </span>
                              </div>
                            </a>
                            </div>
                          </div>
                        </div>

                        <p class="text-center f14" style="margin-top: 30px;" v-if="!this.reservations.length">
                            {{$t('prenotazioni_tavolo.nessuna')}}
                        </p>
                    </div>
                </div>


                <hr>
                <div class="container d-none d-md-block">
                    <div class="row-sezione d-flex justify-content-center">
                            <router-link :to="{name:'user'}">
                                <button type="button" class="btn btn-default">{{$t('btn_indietro')}}</button>
                            </router-link>
                    </div>
                </div>
            </div>
        </div>
        <modal-messaging v-if="this.show_modal" @close="show_modal = false"
                         type="PRENOTAZIONE"
                         :item="this.selected_reservation"
        />
      <modal-feedback v-if="this.show_feedback_modal" @close="show_feedback_modal = false"
                      type="PRENOTAZIONE"
                      :item="this.selected_reservation"
      />
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import {getReserveHistory} from "../../api/account";

    import IncReservationStatus from "./partials/IncReservationStatus";
    import ModalMessaging from "../messaging/partials/ModalMessaging";
    import ModalFeedback from "../orders/partials/ModalFeedback.vue";

    export default {
        name: "History",
        components: {ModalFeedback, ModalMessaging, IncReservationStatus},
        data() {
            return {
                reservations: [],

                show_modal: false,
              show_feedback_modal: false,
                selected_reservation: null
            }
        },
        created() {
            this.fetch();
        },
        computed: {
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            }),
            ...mapState('auth', {
                user: state => state
            }),
            ...mapGetters('chat', {
                getMsgCounterFromId: 'getMsgCounterFromId'
            })
        },
        methods: {
            fetch: function () {
                this.showLoading(true);
                getReserveHistory(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    email: this.user.email,
                    api_key: this.user.api_key,
                    counter_messaggi: false
                }).then((response) => {
                    this.reservations = response.prenotazioni;
                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                }).finally(() => {
                    this.showLoading(false);
                })
            },
            openMessagingModal: function (reservation) {
                this.selected_reservation = reservation;
                this.show_modal = true;
            },
          openFeedbackModal: function (reservation) {
            this.selected_reservation = reservation;
            this.show_feedback_modal = true;
          },
            getConversationMsgCounter: function (reservation) {
                try {
                    return this.getMsgCounterFromId(reservation.chat.id);
                } catch (e) {
                    return null
                }
            },
            ...mapActions('global', [
                'showLoading'
            ])
        }
    }
</script>
